import { gql } from "@apollo/client";


export const RHTVVideoFragment = gql`
  fragment RhtvVideo on RhtvVideo {
    title
    slug
    rhtvVideoContent {
      videoTitle
      youtubeVideoId
      previewVideo
      externalYoutubeLink
      thumbnail {
        ...ACFMedia
      }
      channels {
        nodes {
          ... on RhtvChannel {
            title
            slug
          }
        }
      }
      artists {
        type
        name
        nameLink {
          node {
            uri
          }
        }
        inductee {
          node {
            ... on Inductee {
              title
              uri
            }
          }
        }
      }
    }
  }
`;